import stripHtml from 'utils/stripHtml';

export function shareOnFacebook(checkin) {
    var textDescription = stripHtml(checkin.html),
        postUrl = `https://walkabout.gotdibbs.com/journal/${checkin.id}`,
        socialUrl = `${postUrl}?utm_source=fb&utm_medium=checkin`;

    FB.ui({
        method: 'feed',
        link: socialUrl,
        name: checkin.summary,
        description: textDescription != null && typeof textDescription === 'string' ? 
            textDescription.trim().substr(0, 46) + '...' : null,
        caption: 'Read more at https://walkabout.gotdibbs.com/',
        picture: checkin.place != null && checkin.place.photos != null ? 
            checkin.place.photos[checkin.selectedPhotoIndex] : null,
        redirect_uri: 'https://walkabout.gotdibbs.com/journal'
    });
}


// WEBPACK FOOTER //
// ./src/app/utils/share.js